/**
 * 5.1.1 대상 방화벽 설정 Store
 *
 * @since 2017-12-12
 * @author devp020
 */

export const state = () => ({
  // api url 목록
  url: '/api/pm/use-firewall',
  deviceUrl: '/api/pm/use-firewall/device',
  confirmUrl: '/api/pm/use-firewall',

  // === Table Contents  ===
  rowSelectItems: [],
  tableCondition: {
    selectedRowData: false
  },
  useFireWallList: [],
  useFireWallListFilter: [],
  errorMessage: null
})

export const mutations = {
  setRowSelectItems (state, data) {
    state.rowSelectItems = data
  },
  // 메인 화면 방화벽 설정 조회
  mutUseFirewall (state, payload) {
    state.useFireWallList = payload.filter(item => {
      if (item.device_type === 1) {
        item.device_type_name = 'Stand-Alone'
      } else if (item.device_type === 2) {
        item.device_type_name = 'Master'
      } else {
        item.device_type_name = item.device_type
      }
      return item
    })
  },
  // 대상 방화벽 설정 추가
  // mutPostUseFireWall (state, payload) {
  //   state.useFireWallResult = payload
  // },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  }
}

export const actions = {
  // 대상 방화벽 설정 조회
  async acsUseFireWall ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.url}`)
      if (res.code === 'ok') {
        commit('mutUseFirewall', res.result)
      } else {
        commit('mutUseFirewall', [])
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
    }
    return res
  },
  // 대상 방화벽 설정 추가/삭제
  async acsPostUseFireWall ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${state.url}`, payload, {loading: false, successAlert: false})
      if (data.code !== 'ok') {
        return {code: 'nok', errors: data.result.msg}
      }
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.confirmUrl}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return error
    }
  }
}
export const getters = {}
export const strict = false
